import { createFileRoute } from '@tanstack/react-router';

import { ClientExerciseTakeScreen } from '@/features/engagement/components/ClientExerciseTakeScreen';

export const Route = createFileRoute('/client/exercises/$clientExerciseId')({
  component: ClientExerciseTakeRoute,
});

function ClientExerciseTakeRoute() {
  const { clientExerciseId } = Route.useParams();
  return <ClientExerciseTakeScreen clientExerciseId={clientExerciseId} />;
}
